"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dot = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const dot_styles_1 = require("@/components/common/dot/dot.styles");
const utils_1 = require("@/utils");
const toneTokens = Object.fromEntries(Object.keys(dot_styles_1.dotToneColors).map(tone => [tone, (0, dot_styles_1.dotToneTokens)(tone)]));
/**
 * 색 하나만 갖는 점. 상태 어휘를 갖지 않으므로 색은 tone으로만 고른다.
 * 범례처럼 옆에 붙는 라벨이 이름을 맡는 자리에 쓰고, 점이 스스로 상태를 뜻해야 하면 mm-status-dot을 쓴다.
 */
let Dot = class Dot extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.tone = 'default';
        this.size = '8';
    }
    // 색 면만 그리고 이름은 옆 라벨이 맡으므로 보조 기술에는 드러내지 않는다.
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-hidden', 'true');
    }
};
Dot.styles = (0, lit_1.css) `
    :host {
      ${dot_styles_1.dotStyles}
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('tone', toneTokens))}
    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', dot_styles_1.dotSizeTokens))}
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Dot.prototype, "tone", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], Dot.prototype, "size", void 0);
Dot = __decorate([
    (0, decorators_js_1.customElement)('mm-dot')
], Dot);
exports.Dot = Dot;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG90LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZG90LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFnRDtBQUNoRCxxREFBMkQ7QUFFM0QsbUVBTzJDO0FBQzNDLG1DQUE2QztBQUU3QyxNQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsV0FBVyxDQUNuQyxNQUFNLENBQUMsSUFBSSxDQUFDLDBCQUFhLENBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLElBQUksRUFBRSxJQUFBLDBCQUFhLEVBQUMsSUFBZSxDQUFDLENBQUMsQ0FBQyxDQUMvRSxDQUFBO0FBRUQ7OztHQUdHO0FBRUksSUFBTSxHQUFHLEdBQVQsTUFBTSxHQUFJLFNBQVEsZ0JBQVU7SUFBNUI7O1FBU3NDLFNBQUksR0FBWSxTQUFTLENBQUE7UUFDUCxTQUFJLEdBQVksR0FBRyxDQUFBO0lBT2xGLENBQUM7SUFMQyw0Q0FBNEM7SUFDNUMsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxhQUFhLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFDMUMsQ0FBQzs7QUFmTSxVQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7O1FBRWIsc0JBQVM7OztNQUdYLElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsTUFBTSxFQUFFLFVBQVUsQ0FBQyxDQUFDO01BQ2xELElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsTUFBTSxFQUFFLDBCQUFhLENBQUMsQ0FBQztHQUN4RCxDQUFBO0FBQzBDO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO2lDQUEwQjtBQUNQO0lBQTVELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQUM7aUNBQW9CO0FBVnJFLEdBQUc7SUFEZixJQUFBLDZCQUFhLEVBQUMsUUFBUSxDQUFDO0dBQ1gsR0FBRyxDQWlCZjtBQWpCWSxrQkFBRyJ9